import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/images/logo.png";
import { FaInstagram, FaPinterest, FaTiktok, FaYoutube } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <div className="logo-icon-wrap">
                <img src={logo} alt="zoriplace logo"></img>
              </div>
              <div>
                <span className="footer-logo-main">
                  zori<span style={{ color: "var(--terracotta)" }}>.</span>place
                </span>
                <span className="footer-logo-tagline">декор, що створює дитинство</span>
              </div>
            </Link>
            <div className="footer-social">
              <a
                href="https://www.instagram.com/zori.place.stickers?igsh=dTJrNTFzdHoxYWdk"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="social-link"
              >
                <FaInstagram size={18} />
              </a>

              <a
                href="https://pin.it/6wh3ckAal"
                target="_blank"
                rel="noreferrer"
                aria-label="Pinterest"
                className="social-link"
              >
                <FaPinterest size={18} />
              </a>

              <a
                href="https://www.tiktok.com/@zori.place"
                target="_blank"
                rel="noreferrer"
                aria-label="TikTok"
                className="social-link"
              >
                <FaTiktok size={18} />
              </a>

              <a
                href="https://youtube.com/@zori.place1"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
                className="social-link"
              >
                <FaYoutube size={18} />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Каталог</h4>
            <ul>
              <li>
                <Link to="/catalog">Всі товари</Link>
              </li>
              <li>
                <Link to="/catalog">Наліпки на стіну</Link>
              </li>
              <li>
                <Link to="/catalog">Фотошпалери</Link>
              </li>
              <li>
                <Link to="/catalog">Постери</Link>
              </li>
              <li>
                <Link to="/individual-order">Індивідуальне замовлення</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Інформація</h4>
            <ul>
              <li>
                <Link to="/delivery">Доставка і оплата</Link>
              </li>
              <li>
                <Link to="/certificate">Подарунковий сертифікат</Link>
              </li>
              <li>
                <Link to="/faq">Питання та відповіді</Link>
              </li>
              <li>
                <Link to="/contact">Контакти</Link>
              </li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Допомога</h4>
            <ul>
              <li>
                <Link to="/faq">Питання та відповіді</Link>
              </li>
              <li>
                <Link to="/public-offer">Публічна оферта</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© {new Date().getFullYear()} zori.place. Усі права захищені.</p>
          <p>Зроблено з ♡ для маленьких</p>
        </div>
      </div>
    </footer>
  );
}
